// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Image2 from "../../assets/image/stripe-2.png";
import Image from "../../assets/image/brown.png";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  getAllCard,
  userCheckEligibility,
  userPayment,
} from "../../services/cardsFn";
import { useAuth } from "../../context/AuthContext";
import { useSubscription } from "../../context/SubscriptionContext";
import AppLoader from "../loader/loader";

function Payment_confirm() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isEligible, setIsEligible] = useState(false);
  const [cards, setCards] = useState(null);
  const { userId, login, logoutUserId } = useAuth();
  const { selectedPackage: pkg } = useSubscription();
  const showAlert = (title, text, icon) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: "OK",
    });
  };
  const showErrorAlert = () => {
    Swal.fire({
      title: "Error!",
      text: " Some Problem While Procceding.",
      icon: "error",
      confirmButtonText: "OK",
    });
  };
  useEffect(() => {
    fetchCards();
  }, []);

  const fetchCards = async () => {
    setIsLoading(true);
    try {
      const response = await getAllCard(userId._id);
      if (response.status === 200 || response.status === 201) {
        setCards(response.data.data[0]);
      }
    } catch (error) {
      console.error("Error fetching cards:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   handleCheckEligibility();
  // }, []);

  // const handleCheckEligibility = async () => {
  //   const payload = {
  //     userId: userId._id,
  //     platform: "Stripe",
  //   };
  //   try {
  //     const response = await userCheckEligibility(payload);
  //     if (response.status === 200 || response.status === 201) {
  //       const { trialEligible } = response.data.data;

  //       if (trialEligible) {
  //         showAlert(true, "You are not eligible for the subscription", "error");
  //       }

  //       return;
  //     }
  //   } catch (error) {
  //     console.error("Error checking eligibility:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handlePayment = async () => {
    setIsLoading(true);

    try {
      const payload = {
        userId: userId._id,
        // paymentId: cards?.id,
        // amount: pkg?.price,
        subscriptionId: pkg?._id,
      };

      const response = await userPayment(payload);

      if (response.status === 200 || response.status === 201) {
        showAlert("Success", response?.data.message || "success");
        navigate("/payment-success");
        login(response.data.data);
        logoutUserId();
      } else {
        showAlert("Error", response?.data.message || "error");
      }
    } catch (error) {
      console.error("Payment error:", error);
      showAlert("Error", error.message || "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handlenavigateBack = () => {
    navigate(-1);
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <section className="payment-confrim-section">
        <div className="payment-confrim-hero">
          <div className="container box-con">
            <div className="box box-div">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-2 col-lg-2 col-md-2 col-sm-2 icon-times-col">
                  <div className="icon-times" onClick={handlenavigateBack}>
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      className="sub-icon-times"
                    />
                  </div>
                </div>
                <div className="col-9 col-lg-9 col-md-9 col-sm-12">
                  <h2>payment</h2>
                </div>
                {/* <div className="col-1 col-lg-1 col-md-1 col-sm-1 icon-times2-col p-0">
                  <div className="icon-times2">
                    <img src={Image} />
                  </div>
                </div> */}
              </div>
              <div className="row st-h">
                <div className="col-md-10 col-sm-10 col-10 py-method">
                  <h6>payment method</h6>
                </div>
                <div className="col-md-2 col-sm-2 col-2 py-method-img">
                  {" "}
                  <img src={Image2} />{" "}
                </div>
              </div>
              {/* <div className="container-fluid pay-select">
                  <div className="row d-flex justify-content-center align-items-center">
                    <div className="col-md-3 col-sm-3 col-3">
                      <img src={Image2} />{" "}
                    </div>
                    <div className="col-md-7 col-sm-7 col-7">
                      {" "}
                      <h6>{cards?.card?.brand}</h6>
                      <br />
                      <h5> **** **** **** {cards?.card?.last4}</h5>
                    </div>
                    <div className="col-md-2 col-sm-2 col-2 r-btn">
                      {" "}
                      <input
                        type="radio"
                        name=""
                        id=""
                        className="radio-input"
                      />
                    </div>
                  </div>
                </div> */}

              <div className="container-fluid pay-select">
                <div className="row d-flex justify-content-center align-items-center">
                  <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                    <img src={Image2} />{" "}
                  </div>
                  <div className="col-lg-8 col-md-8 col-sm-8 col-8">
                    {" "}
                    <h6>{cards?.card?.brand}</h6>
                    <h5>**** **** **** {cards?.card?.last4}</h5>
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-2 col-2 r-btn">
                    {" "}
                    <input type="radio" name="" id="" className="radio-input" />
                  </div>
                </div>
              </div>

              <h3 className="total-py">total payable amount</h3>

              <div className="row subtotal-confrim">
                <hr />
                <div className="col-6 col-lg-6 col-md-6 col-sm-6 sub-total-confrim">
                  <h6>Subtotal</h6>
                </div>
                <div className="col-6 col-lg-6 col-md-6 col-sm-6 sub-price-confrim">
                  <h6>$ {pkg?.price || "0.00"}</h6>
                </div>
              </div>
              <div className="row tax-total-confrim">
                <div className="col-6 col-lg-6 col-md-6 col-sm-6 sub-total-confrim">
                  <h6>Tax</h6>
                </div>
                <div className="col-6 col-lg-6 col-md-6 col-sm-6 sub-price-confrim">
                  <h6>$ 0.00</h6>
                </div>
                <hr />
              </div>
              <div className="row amount-confrim">
                <div className="col-6 col-lg-6 col-md-6 col-sm-6 sub-total-confrim">
                  <h6>Total Amount</h6>
                </div>
                <div className="col-6 col-lg-6 col-md-6 col-sm-6 sub-price-confrim">
                  <h6>$ {pkg?.price || "0.00"}</h6>
                </div>
              </div>

              <button className="btn-1" onClick={handlePayment}>
                pay now
              </button>
            </div>
          </div>
        </div>
        {/* </div> */}
      </section>
    </>
  );
}

export default Payment_confirm;
